import React from 'react';
import { useNavigate } from 'react-router-dom';
import KpiCard from './KpiCard';

/** "Total Orders" card; click opens the order page with the Customer Complete / Pending Order cards. */
export default function TotalOrdersCards({ total }) {
  const navigate = useNavigate();
  const open = () => navigate('/order-analysis', { state: { focus: 'orders' } });
  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Total Orders"
      title="Click to see Customer Complete / Pending orders"
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
      style={{ display: 'flex', flex: '1 1 160px', cursor: 'pointer' }}
    >
      <KpiCard label="Total Orders ▸" value={total} />
    </div>
  );
}
